import './i18n';
import React from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
} from "react-router-dom";import ReactDOM from 'react-dom';
import './index.css';
import Tcplayer from './router/tcplayer';
import TcplayerLite from './router/tcplayerLite.tsx';

/* eslint-disable no-undef */
window.lang = LANGUAGE;
window.mode = MODE;

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Tcplayer />} />
        <Route path="tcplayerlite" element={<TcplayerLite />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
